// import React, { useState, useEffect, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import { API_BASE_URL } from "../../../Config/Config";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { fetchSessionData } from "../../../Redux/Sessions/sessionSlice";
// import SuccessImg from "../../../Assets/Images/CommanImages/Informative.png";
// import "./updatedusergroup.css";

// function UserGroupRoleAccess({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { coursesdata } = useSelector((state) => state.course);
//   const { sessionsData } = useSelector((state) => state.sessions);

//   const accessToken = localStorage.getItem("other");
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

//   // Received from table: either selectedRowsData (array of rows) + headers,
//   // OR a single row via rowData+headers (from hyperlink). Support both.
//   const passedHeaders = location.state?.headers ?? [];
//   const passedSelectedRowsData = location.state?.selectedRowsData ?? null;
//   const passedRow = location.state?.rowData ?? null;

//   // We'll pick the "sourceRow" (array) from selectedRowsData[0] if provided else rowData
//   const sourceRow = Array.isArray(passedSelectedRowsData) && passedSelectedRowsData.length > 0
//     ? passedSelectedRowsData[0]
//     : Array.isArray(passedRow)
//     ? passedRow
//     : [];

//   // helper to get value by header name (header expected cleaned to readable name)
//   const getByHeaderFrom = (headersArray, rowArray, headerName) => {
//     if (!Array.isArray(headersArray) || headersArray.length === 0) return "";
//     const idx = headersArray.indexOf(headerName);
//     if (idx === -1) return "";
//     const val = rowArray[idx];
//     return val === null || val === undefined ? "" : val;
//   };

//   // Also try to be tolerant if headers have prefixes like "t*" or "n*"
//   const getByAnyHeader = (names) => {
//     for (const n of names) {
//       // direct
//       const v = getByHeaderFrom(passedHeaders, sourceRow, n);
//       if (v !== "") return v;
//       // and prefixed variant (strip potential prefixes in headers array)
//       const prefixedIndex = passedHeaders.findIndex((h) =>
//         String(h).endsWith(n) || String(h).replace(/^[a-z]\*/, "") === n
//       );
//       if (prefixedIndex !== -1) {
//         const val = sourceRow[prefixedIndex];
//         if (val !== undefined && val !== null && val !== "") return val;
//       }
//     }
//     return "";
//   };

//   // Build initial states using header mapping (use getByAnyHeader over common names)
//   const [studentGroupName, setStudentGroupName] = useState(() =>
//     getByAnyHeader(["User Group Name", "UserGroupName", "User Group_Name", "User Group name"])
//   );
//   const [studentGroupDesc, setStudentGroupDesc] = useState(() =>
//     getByAnyHeader(["User Group Description", "UserGroupDescription", "User Group Description"])
//   );
//   const [emailFlag, setEmailFlag] = useState(() =>
//     getByAnyHeader(["Email Flag", "EmailFlag"])
//   );
//   const [messageFlag, setMessageFlag] = useState(() =>
//     getByAnyHeader(["Message Flag", "MessageFlag"])
//   );
//   const [comments, setComments] = useState(() =>
//     getByAnyHeader(["Comments"])
//   );
//   const [status, setStatus] = useState(() =>
//     getByAnyHeader(["Status"])
//   );
//   const [lastModifiedDate, setLastModifiedDate] = useState(() =>
//     getByAnyHeader(["Last Modified Date", "LastModifiedDate"])
//   );
//   const [createdBy, setCreatedBy] = useState(() =>
//     getByAnyHeader(["Created By", "CreatedBy"])
//   );
//   const [groupOwnerName, setGroupOwnerNameState] = useState(() =>
//     getByAnyHeader(["Group Owner Name", "GroupOwnerName"])
//   );
//   const [defaultUserGroup, setDefaultUserGroup] = useState(() =>
//     getByAnyHeader(["Default Group", "DefaultUserGroup"])
//   );

//   // QUESTION REVIEWER GROUP fields
//   const [quesReviewerGroupId, setQuesReviewerGroupId] = useState(() =>
//     getByAnyHeader(["Ques Reviewer Group ID", "QuesReviewerGroupID"])
//   );
//   const [courseIdField, setCourseIdField] = useState(() =>
//     getByAnyHeader(["Course ID", "CourseID"])
//   );
//   const [courseNameField, setCourseNameField] = useState(() =>
//     getByAnyHeader(["Course Name", "CourseName"])
//   );
//   const [subjectIdField, setSubjectIdField] = useState(() =>
//     getByAnyHeader(["Subject ID", "SubjectID"])
//   );
//   const [subjectNameField, setSubjectNameField] = useState(() =>
//     getByAnyHeader(["Subject Name", "SubjectName"])
//   );
//   const [reviewerGroupType, setReviewerGroupType] = useState(() =>
//     getByAnyHeader(["Reviewer Group Type", "ReviewerGroupType"])
//   );
//   const [facultyReviewLevel, setFacultyReviewLevel] = useState(() =>
//     getByAnyHeader(["Faculty Review Level", "FacultyReviewLevel"])
//   );

//   // If location.state later changes (unlikely), update fields accordingly
//   useEffect(() => {
//     setStudentGroupName(getByAnyHeader(["User Group Name", "UserGroupName"]));
//     setStudentGroupDesc(getByAnyHeader(["User Group Description", "UserGroupDescription"]));
//     setEmailFlag(getByAnyHeader(["Email Flag", "EmailFlag"]));
//     setMessageFlag(getByAnyHeader(["Message Flag", "MessageFlag"]));
//     setComments(getByAnyHeader(["Comments"]));
//     setStatus(getByAnyHeader(["Status"]));
//     setLastModifiedDate(getByAnyHeader(["Last Modified Date", "LastModifiedDate"]));
//     setCreatedBy(getByAnyHeader(["Created By", "CreatedBy"]));
//     setGroupOwnerNameState(getByAnyHeader(["Group Owner Name", "GroupOwnerName"]));
//     setDefaultUserGroup(getByAnyHeader(["Default Group", "DefaultUserGroup"]));
//     setQuesReviewerGroupId(getByAnyHeader(["Ques Reviewer Group ID", "QuesReviewerGroupID"]));
//     setCourseIdField(getByAnyHeader(["Course ID", "CourseID"]));
//     setCourseNameField(getByAnyHeader(["Course Name", "CourseName"]));
//     setSubjectIdField(getByAnyHeader(["Subject ID", "SubjectID"]));
//     setSubjectNameField(getByAnyHeader(["Subject Name", "SubjectName"]));
//     setReviewerGroupType(getByAnyHeader(["Reviewer Group Type", "ReviewerGroupType"]));
//     setFacultyReviewLevel(getByAnyHeader(["Faculty Review Level", "FacultyReviewLevel"]));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [location.state]);

//   // keep user-groups/roles block states
//   const [selectedUserGroups, setSelectedUserGroups] = useState([]);
//   const [userGroupOptions, setUserGroupOptions] = useState([]);
//   const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);
//   const [isOpenAddScreens, setIsOpenAddScreens] = useState(true);
//   const isUpdatingFromTable = useRef(false);

//   // load course/session lists
//   useEffect(() => {
//     dispatch(fetchCourseData());
//     dispatch(fetchSessionData());
//   }, [dispatch]);

//   // const fetchUserGroups = async (searchKey) => {
//   //   if (!searchKey?.trim()) {
//   //     setUserGroupOptions([]);
//   //     return;
//   //   }
//   //   try {
//   //     const res = await fetch(
//   //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-all-user-groups-search-key?client_branch_id=${clientBranchId}&user_name=${userName}&search_key=${encodeURIComponent(
//   //         searchKey
//   //       )}&search_by_screen_report_name=${isUserGroupEnabled}`,
//   //       {
//   //         headers: { Authorization: `Bearer ${accessToken}` },
//   //       }
//   //     );
//   //     const result = await res.json();
//   //     if (result.status === 200 && Array.isArray(result.data)) {
//   //       setUserGroupOptions(
//   //         result.data.map((g) => ({ id: g.user_group_id, label: g.user_group_name, fullData: g }))
//   //       );
//   //     } else {
//   //       setUserGroupOptions([]);
//   //     }
//   //   } catch (err) {
//   //     console.error("Error fetching user groups:", err);
//   //     setUserGroupOptions([]);
//   //   }
//   // };

//   // replace existing fetchUserGroups with this
// const fetchUserGroups = async (searchKey) => {
//   // if user cleared input AND there are no selected roles, clear options
//   if (!searchKey?.trim()) {
//     // keep selected ones (so table can still render selected rows)
//     setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
//     return;
//   }

//   try {
//     const res = await fetch(
//       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-all-roles-by-search-key?client_branch_id=${clientBranchId}&user_name=${userName}&search_key=${encodeURIComponent(
//         searchKey
//       )}&search_by_screen_report_name=${isUserGroupEnabled}`,
//       {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       }
//     );
//     const result = await res.json();

//     if (result.status === 200 && Array.isArray(result.data)) {
//       // map API roles -> dropdown options
//       const incomingOptions = result.data.map((r) => ({
//         id: r.role_id,
//         label: r.role_name || r.role_code || `Role ${r.role_id}`,
//         fullData: r,
//       }));

//       // merge with currently selected options so we don't lose them
//       setUserGroupOptions((prev) => {
//         const selectedPrev = Array.isArray(prev) ? prev.filter((p) => selectedUserGroups.includes(p.id)) : [];
//         // add incoming that aren't already in selectedPrev
//         const merged = [
//           ...selectedPrev,
//           ...incomingOptions.filter((inc) => !selectedPrev.some((p) => p.id === inc.id)),
//         ];
//         return merged;
//       });
//     } else {
//       // no results: keep selected ones only
//       setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
//     }
//   } catch (err) {
//     console.error("Error fetching roles:", err);
//     // on error, keep selected ones so table doesn't break
//     setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
//   }
// };



//   // Roles table config
//   const headersForUserGroups = [
//     "User Group ID",
//     "User Group Name",
//     "Description",
//     "Group Owner Name",
//     "Status",
//   ];
//   const tableDataForUserGroups = selectedUserGroups
//     .map((id) => {
//       const opt = userGroupOptions.find((o) => o.id === id);
//       if (!opt?.fullData) return null;
//       const g = opt.fullData;
//       return [
//         id,
//         g.user_group_name || "---",
//         g.user_group_desc || "---",
//         g.group_owner_name || "---",
//         g.status || "---",
//       ];
//     })
//     .filter(Boolean);

//   const handleDeleteRowForUserGroups = (rowId) => {
//     setUserGroupOptions((prev) => prev.filter((o) => o.id !== rowId));
//     setSelectedUserGroups((prev) => prev.filter((id) => id !== rowId));
//   };

//   const handleSave = () => {
//     const payload = {
//       user_group_name: studentGroupName,
//       user_group_desc: studentGroupDesc,
//       email_flag: emailFlag,
//       message_flag: messageFlag,
//       comments,
//       status,
//       created_by: createdBy,
//       last_modified_by: lastModifiedDate,
//       group_owner_name: groupOwnerName,
//       default_user_group: defaultUserGroup,
//       // reviewer group fields
//       ques_reviewer_group_id: quesReviewerGroupId,
//       course_id: courseIdField,
//       course_name: courseNameField,
//       subject_id: subjectIdField,
//       subject_name: subjectNameField,
//       reviewer_group_type: reviewerGroupType,
//       faculty_review_level: facultyReviewLevel,
//       selected_roles: selectedUserGroups,
//     };
//     console.log("Save payload (mock):", payload);
//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Saved (mock) — implement API call as needed.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(SuccessImg);
//       setIsMessageBoxVisible(true);
//       setTimeout(() => setIsMessageBoxVisible(false), 2000);
//     }
//   };

//   const reviewerGroupLabel = () => {
//     if (quesReviewerGroupId === "" || quesReviewerGroupId === null) return "";
//     return String(quesReviewerGroupId);
//   };

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">User Group - Role Access</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn" onClick={() => navigate("/updated_user_groups_dashboard")}>
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSave}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       {/* GROUP INFORMATION */}
//       <div className="ques-paper-del">
//         <div className="personal-header"><div className="header"><label>GROUP INFROMATION</label></div></div>
//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs label="User Group Name" type="text" required value={studentGroupName} disabled />
//               </div>
//               <div className="item2">
//                 <FormInputs label="User Group Description" type="text" required value={studentGroupDesc} disabled />
//               </div>
//               <div className="item3">
//                 <FormInputs label="Message Flag" value={messageFlag} disabled />
//               </div>
//               <div className="item4">
//                 <FormInputs label="Email Flag" value={emailFlag} disabled />
//               </div>
//               <div className="item5">
//                 <FormInputs label="Created By" type="text" value={createdBy} disabled />
//               </div>
//               <div className="item6">
//                 <FormInputs label="Select Group Owner Name" value={groupOwnerName} disabled />
//               </div>
//               <div className="item7" style={{ gridColumn: "1 / 2" }}>
//                 <FormInputs label="Last Modified Date" type="text" value={lastModifiedDate} disabled />
//               </div>
//               <div className="item8" style={{ gridColumn: "2 / 3" }}>
//                 <FormInputs label="Default Group" value={defaultUserGroup} disabled />
//               </div>
//               <div className="item9" style={{ gridColumn: "3 / 4" }}>
//                 <FormInputs label="Status" value={status} disabled />
//               </div>
//               <div className="item10" style={{ gridColumn: "1 / -1" }}>
//                 <FormInputs label="Comments" type="text" value={comments} disabled />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* QUESTION REVIEWER GROUP */}
//       <div className="ques-paper-del">
//         <div className="personal-header"><div className="header"><label>QUESTION REVIEWER GROUP</label></div></div>
//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs label="Is this a Question Reviewer Group?" type="text" value={reviewerGroupLabel()} disabled />
//               </div>
//               <div className="item2">
//                 <FormInputs label="Course" type="text" value={courseNameField || courseIdField} disabled />
//               </div>
//               <div className="item3">
//                 <FormInputs label="Subject" type="text" value={subjectNameField || subjectIdField} disabled />
//               </div>
//               <div className="item4">
//                 <FormInputs label="HOD or Faculty Reviewer Group?" type="text" value={reviewerGroupType} disabled />
//               </div>
//               <div className="item5">
//                 <FormInputs label="Reviewer Level" type="text" value={facultyReviewLevel ? String(facultyReviewLevel) : ""} disabled />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ROLES */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header"><label>ROLES</label></div>
//           <div className="accordion-btn" onClick={() => setIsOpenAddScreens(!isOpenAddScreens)}>
//             {isOpenAddScreens ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenAddScreens && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del" style={{ padding: "20px 0px 20px 10px" }}>
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1" style={{ gridColumn: "1 / -1" }}>
//                   <DropdownWithPagination
//                     label="Search Role"
//                     width="31%"
//                     selected={selectedUserGroups}
//                     setSelected={setSelectedUserGroups}
//                     onSearchInputChange={fetchUserGroups}
//                     options={userGroupOptions}
//                     isRequired={true}
//                     showSelectAll={true}
//                     allowMultiple={true}
//                     itemsPerPage={4}
//                     placeholder={isUserGroupEnabled ? "Type Role Name or Screen name or Report Name..." : "Type Role Name"}
//                     showLabelCheckbox={true}
//                     labelCheckboxChecked={isUserGroupEnabled}
//                     onLabelCheckboxChange={setIsUserGroupEnabled}
//                     labelCheckboxText="Search by Screen/Report Name"
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
//                   <TableWithCrossStudentGroup
//                     headers={headersForUserGroups}
//                     data={tableDataForUserGroups}
//                     searchPlaceholder="Search user groups..."
//                     selectedRows={selectedUserGroups}
//                     setSelectedRows={setSelectedUserGroups}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteRowForUserGroups}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default UserGroupRoleAccess;






















// import React, { useState, useEffect, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import { API_BASE_URL } from "../../../Config/Config";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { fetchSessionData } from "../../../Redux/Sessions/sessionSlice";
// import SuccessImg from "../../../Assets/Images/CommanImages/Informative.png";
// import "./updatedusergroup.css";

// function UserGroupRoleAccess({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { coursesdata } = useSelector((state) => state.course);
//   const { sessionsData } = useSelector((state) => state.sessions);

//   const accessToken = localStorage.getItem("other");
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

//   // Received from table: either selectedRowsData (array of rows) + headers,
//   // OR a single row via rowData+headers (from hyperlink). Support both.
//   const passedHeaders = location.state?.headers ?? [];
//   const passedSelectedRowsData = location.state?.selectedRowsData ?? null;
//   const passedRow = location.state?.rowData ?? null;

//   // We'll pick the "sourceRow" (array) from selectedRowsData[0] if provided else rowData
//   const sourceRow = Array.isArray(passedSelectedRowsData) && passedSelectedRowsData.length > 0
//     ? passedSelectedRowsData[0]
//     : Array.isArray(passedRow)
//     ? passedRow
//     : [];

//   // helper to get value by header name (header expected cleaned to readable name)
//   const getByHeaderFrom = (headersArray, rowArray, headerName) => {
//     if (!Array.isArray(headersArray) || headersArray.length === 0) return "";
//     const idx = headersArray.indexOf(headerName);
//     if (idx === -1) return "";
//     const val = rowArray[idx];
//     return val === null || val === undefined ? "" : val;
//   };

//   // Also try to be tolerant if headers have prefixes like "t*" or "n*"
//   const getByAnyHeader = (names) => {
//     for (const n of names) {
//       // direct
//       const v = getByHeaderFrom(passedHeaders, sourceRow, n);
//       if (v !== "") return v;
//       // and prefixed variant (strip potential prefixes in headers array)
//       const prefixedIndex = passedHeaders.findIndex((h) =>
//         String(h).endsWith(n) || String(h).replace(/^[a-z]\*/, "") === n
//       );
//       if (prefixedIndex !== -1) {
//         const val = sourceRow[prefixedIndex];
//         if (val !== undefined && val !== null && val !== "") return val;
//       }
//     }
//     return "";
//   };

//   // Build initial states using header mapping (use getByAnyHeader over common names)
//   const [studentGroupName, setStudentGroupName] = useState(() =>
//     getByAnyHeader(["User Group Name", "UserGroupName", "User Group_Name", "User Group name"])
//   );
//   const [studentGroupDesc, setStudentGroupDesc] = useState(() =>
//     getByAnyHeader(["User Group Description", "UserGroupDescription", "User Group Description"])
//   );
//   const [emailFlag, setEmailFlag] = useState(() =>
//     getByAnyHeader(["Email Flag", "EmailFlag"])
//   );
//   const [messageFlag, setMessageFlag] = useState(() =>
//     getByAnyHeader(["Message Flag", "MessageFlag"])
//   );
//   const [comments, setComments] = useState(() =>
//     getByAnyHeader(["Comments"])
//   );
//   const [status, setStatus] = useState(() =>
//     getByAnyHeader(["Status"])
//   );
//   const [lastModifiedDate, setLastModifiedDate] = useState(() =>
//     getByAnyHeader(["Last Modified Date", "LastModifiedDate"])
//   );
//   const [createdBy, setCreatedBy] = useState(() =>
//     getByAnyHeader(["Created By", "CreatedBy"])
//   );
//   const [groupOwnerName, setGroupOwnerNameState] = useState(() =>
//     getByAnyHeader(["Group Owner Name", "GroupOwnerName"])
//   );
//   const [defaultUserGroup, setDefaultUserGroup] = useState(() =>
//     getByAnyHeader(["Default Group", "DefaultUserGroup"])
//   );

//   // QUESTION REVIEWER GROUP fields
//   const [quesReviewerGroupId, setQuesReviewerGroupId] = useState(() =>
//     getByAnyHeader(["Ques Reviewer Group ID", "QuesReviewerGroupID"])
//   );
//   const [courseIdField, setCourseIdField] = useState(() =>
//     getByAnyHeader(["Course ID", "CourseID"])
//   );
//   const [courseNameField, setCourseNameField] = useState(() =>
//     getByAnyHeader(["Course Name", "CourseName"])
//   );
//   const [subjectIdField, setSubjectIdField] = useState(() =>
//     getByAnyHeader(["Subject ID", "SubjectID"])
//   );
//   const [subjectNameField, setSubjectNameField] = useState(() =>
//     getByAnyHeader(["Subject Name", "SubjectName"])
//   );
//   const [reviewerGroupType, setReviewerGroupType] = useState(() =>
//     getByAnyHeader(["Reviewer Group Type", "ReviewerGroupType"])
//   );
//   const [facultyReviewLevel, setFacultyReviewLevel] = useState(() =>
//     getByAnyHeader(["Faculty Review Level", "FacultyReviewLevel"])
//   );

//   // user_group_id extracted from incoming row (needed for GET roles by group & update)
//   const [userGroupId, setUserGroupId] = useState(() =>
//     getByAnyHeader(["User Group ID", "UserGroupID", "user_group_id"])
//   );

//   // If location.state later changes (unlikely), update fields accordingly
//   useEffect(() => {
//     setStudentGroupName(getByAnyHeader(["User Group Name", "UserGroupName"]));
//     setStudentGroupDesc(getByAnyHeader(["User Group Description", "UserGroupDescription"]));
//     setEmailFlag(getByAnyHeader(["Email Flag", "EmailFlag"]));
//     setMessageFlag(getByAnyHeader(["Message Flag", "MessageFlag"]));
//     setComments(getByAnyHeader(["Comments"]));
//     setStatus(getByAnyHeader(["Status"]));
//     setLastModifiedDate(getByAnyHeader(["Last Modified Date", "LastModifiedDate"]));
//     setCreatedBy(getByAnyHeader(["Created By", "CreatedBy"]));
//     setGroupOwnerNameState(getByAnyHeader(["Group Owner Name", "GroupOwnerName"]));
//     setDefaultUserGroup(getByAnyHeader(["Default Group", "DefaultUserGroup"]));
//     setQuesReviewerGroupId(getByAnyHeader(["Ques Reviewer Group ID", "QuesReviewerGroupID"]));
//     setCourseIdField(getByAnyHeader(["Course ID", "CourseID"]));
//     setCourseNameField(getByAnyHeader(["Course Name", "CourseName"]));
//     setSubjectIdField(getByAnyHeader(["Subject ID", "SubjectID"]));
//     setSubjectNameField(getByAnyHeader(["Subject Name", "SubjectName"]));
//     setReviewerGroupType(getByAnyHeader(["Reviewer Group Type", "ReviewerGroupType"]));
//     setFacultyReviewLevel(getByAnyHeader(["Faculty Review Level", "FacultyReviewLevel"]));
//     setUserGroupId(getByAnyHeader(["User Group ID", "UserGroupID", "user_group_id"]));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [location.state]);

//   // keep user-groups/roles block states
//   const [selectedUserGroups, setSelectedUserGroups] = useState([]);
//   const [initialSelectedUserGroups, setInitialSelectedUserGroups] = useState([]); // for dirty check
//   const [userGroupOptions, setUserGroupOptions] = useState([]);
//   const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);
//   const [isOpenAddScreens, setIsOpenAddScreens] = useState(true);
//   const isUpdatingFromTable = useRef(false);

//   // load course/session lists
//   useEffect(() => {
//     dispatch(fetchCourseData());
//     dispatch(fetchSessionData());
//   }, [dispatch]);

//   // fetch roles by search-key (server-side) - unchanged logic except new endpoint merge behavior
//   const fetchUserGroups = async (searchKey) => {
//     // if default group is true, search must be inactive
//     const defGroupTrue = String(defaultUserGroup).toLowerCase() === "true" || defaultUserGroup === true;
//     if (defGroupTrue) {
//       // keep selections but do not fetch anything new
//       setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
//       return;
//     }

//     // if user cleared input AND there are no selected roles, clear options
//     if (!searchKey?.trim()) {
//       // keep selected ones (so table can still render selected rows)
//       setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
//       return;
//     }

//     try {
//       const res = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-all-roles-by-search-key?client_branch_id=${clientBranchId}&user_name=${userName}&search_key=${encodeURIComponent(
//           searchKey
//         )}&search_by_screen_report_name=${isUserGroupEnabled}`,
//         {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         }
//       );
//       const result = await res.json();

//       if (result.status === 200 && Array.isArray(result.data)) {
//         // map API roles -> dropdown options
//         const incomingOptions = result.data.map((r) => ({
//           id: r.role_id,
//           // label: r.role_name || r.role_code || `Role ${r.role_id}`,
//           label: `${r.role_code}/${r.role_name}/${r.role_desc}`.trim(),
//           fullData: r,
//         }));

//         // merge with currently selected options so we don't lose them
//         setUserGroupOptions((prev) => {
//           const selectedPrev = Array.isArray(prev) ? prev.filter((p) => selectedUserGroups.includes(p.id)) : [];
//           // add incoming that aren't already in selectedPrev
//           const merged = [
//             ...selectedPrev,
//             ...incomingOptions.filter((inc) => !selectedPrev.some((p) => p.id === inc.id)),
//           ];
//           return merged;
//         });
//       } else {
//         // no results: keep selected ones only
//         setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
//       }
//     } catch (err) {
//       console.error("Error fetching roles:", err);
//       // on error, keep selected ones so table doesn't break
//       setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
//     }
//   };

//   // NEW: fetch existing roles for this user group id and populate selectedUserGroups + options
//   useEffect(() => {
//     const fetchRolesByUserGroupId = async (ugId) => {
//       if (!ugId) return;
//       try {
//         const res = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-roles-by-user-group-id?user_group_id=${ugId}`,
//           {
//             headers: { Authorization: `Bearer ${accessToken}` },
//           }
//         );
//         const result = await res.json();
//         if (result.status === 200 && Array.isArray(result.data)) {
//           // if default group true, we must hide roles (as per requirement)
//           const defGroupTrue = String(defaultUserGroup).toLowerCase() === "true" || defaultUserGroup === true;
//           if (defGroupTrue) {
//             // clear display and disable search/save via other logic
//             setUserGroupOptions([]);
//             setSelectedUserGroups([]);
//             setInitialSelectedUserGroups([]);
//             return;
//           }

//           const opts = result.data.map((r) => ({
//             id: r.role_id,
//             label: r.role_name || r.role_code || `Role ${r.role_id}`,
//             fullData: r,
//           }));

//           const ids = opts.map((o) => o.id);

//           setUserGroupOptions(opts);
//           setSelectedUserGroups(ids);
//           setInitialSelectedUserGroups(ids);
//         } else {
//           setUserGroupOptions([]);
//           setSelectedUserGroups([]);
//           setInitialSelectedUserGroups([]);
//         }
//       } catch (err) {
//         console.error("Error fetching roles by group id:", err);
//         setUserGroupOptions([]);
//         setSelectedUserGroups([]);
//         setInitialSelectedUserGroups([]);
//       }
//     };

//     // ensure userGroupId is numeric or present
//     if (userGroupId) {
//       fetchRolesByUserGroupId(userGroupId);
//     } else {
//       // if no group id (maybe new), clear
//       setUserGroupOptions([]);
//       setSelectedUserGroups([]);
//       setInitialSelectedUserGroups([]);
//     }
//     // run when userGroupId or defaultUserGroup changes
//   }, [userGroupId, defaultUserGroup]); // eslint-disable-line

//   // Roles table config
//   const headersForUserGroups = [
//     "Role ID",
//     "Role Code",
//     "Role Name",
//     "Role Description",
//     "Status",
//     "Created Date",
//     "No Of Users",
//     "Screen Names",
//     "Report Names",
//   ];

//   // Build table data for roles (first column must be id as table uses row[0] as id)
//   const tableDataForUserGroups = selectedUserGroups
//     .map((id) => {
//       const opt = userGroupOptions.find((o) => o.id === id);
//       if (!opt?.fullData) return null;
//       const g = opt.fullData;
//       // create screen_names and report_names as newline separated string (for multiline rendering)
//       const screens = Array.isArray(g.screen_names) && g.screen_names.length > 0 ? g.screen_names.join("\n") : "";
//       const reports = Array.isArray(g.report_names) && g.report_names.length > 0 ? g.report_names.join("\n") : "";

//       return [
//         id,
//         g.role_name || "---",
//          g.role_code || "---",
//         g.role_desc || "---",
//         g.status || "---",
//         g.create_date ? String(g.create_date) : "---",
//         typeof g.no_of_users !== "undefined" ? g.no_of_users : "---",
//         screens,
//         reports,
//       ];
//     })
//     .filter(Boolean);

//   const handleDeleteRowForUserGroups = (rowId) => {
//     setUserGroupOptions((prev) => prev.filter((o) => o.id !== rowId));
//     setSelectedUserGroups((prev) => prev.filter((id) => id !== rowId));
//   };

//   // helper: check dirty (selected changed vs initial)
//   const isDirty = () => {
//     // both arrays of ids
//     const a = Array.isArray(initialSelectedUserGroups) ? initialSelectedUserGroups.slice().sort((x,y)=>x-y) : [];
//     const b = Array.isArray(selectedUserGroups) ? selectedUserGroups.slice().sort((x,y)=>x-y) : [];
//     if (a.length !== b.length) return true;
//     for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return true;
//     return false;
//   };

//   const reviewerGroupLabel = () => {
//     if (quesReviewerGroupId === "" || quesReviewerGroupId === null) return "";
//     return String(quesReviewerGroupId);
//   };

//   // SAVE (update) — call update-user-group-roles API
//   const handleSave = async () => {
//     // if default group true, don't allow save
//     const defGroupTrue = String(defaultUserGroup).toLowerCase() === "true" || defaultUserGroup === true;
//     if (defGroupTrue) return;

//     // only save when dirty
//     if (!isDirty()) return;

//     // payload: list of role ids in body; user_group_id & user_name as query params
//     try {
//       const payload = selectedUserGroups || [];
//       const res = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-user-group-roles?user_group_id=${userGroupId}&user_name=${userName}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           body: JSON.stringify(payload),
//         }
//       );
//       const result = await res.json();
//       if (result && (result.status === 200 || result.status === "200")) {
//         // update initial selected to current so SAVE becomes dim again
//         setInitialSelectedUserGroups([...selectedUserGroups]);

//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Saved successfully.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(SuccessImg);
//           setIsMessageBoxVisible(true);
//           setTimeout(() => setIsMessageBoxVisible(false), 2000);
//         }
//       } else {
//         // show error
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <span>Failed to save roles. Try again.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(null);
//           setIsMessageBoxVisible(true);
//           setTimeout(() => setIsMessageBoxVisible(false), 3000);
//         }
//       }
//     } catch (err) {
//       console.error("Error updating user group roles:", err);
//       if (setMessageBox) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>Failed to save roles. Try again.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(null);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => setIsMessageBoxVisible(false), 3000);
//       }
//     }
//   };

//   // decide save button disabled state
//   const defGroupTrue = String(defaultUserGroup).toLowerCase() === "true" || defaultUserGroup === true;
//   const saveDisabled = defGroupTrue || !isDirty();

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">User Group - Role Access</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn" onClick={() => navigate("/updated_user_groups_dashboard")}>
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSave} disabled={saveDisabled} style={{ opacity: saveDisabled ? 0.6 : 1, cursor: saveDisabled ? "not-allowed" : "pointer" }}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       {/* GROUP INFORMATION */}
//       <div className="ques-paper-del">
//         <div className="personal-header"><div className="header"><label>GROUP INFROMATION</label></div></div>
//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs label="User Group Name" type="text" required value={studentGroupName} disabled />
//               </div>
//               <div className="item2">
//                 <FormInputs label="User Group Description" type="text" required value={studentGroupDesc} disabled />
//               </div>
//               <div className="item3">
//                 <FormInputs label="Message Flag" value={messageFlag} disabled />
//               </div>
//               <div className="item4">
//                 <FormInputs label="Email Flag" value={emailFlag} disabled />
//               </div>
//               <div className="item5">
//                 <FormInputs label="Created By" type="text" value={createdBy} disabled />
//               </div>
//               <div className="item6">
//                 <FormInputs label="Select Group Owner Name" value={groupOwnerName} disabled />
//               </div>
//               <div className="item7" style={{ gridColumn: "1 / 2" }}>
//                 <FormInputs label="Last Modified Date" type="text" value={lastModifiedDate} disabled />
//               </div>
//               <div className="item8" style={{ gridColumn: "2 / 3" }}>
//                 <FormInputs label="Default Group" value={defaultUserGroup} disabled />
//               </div>
//               <div className="item9" style={{ gridColumn: "3 / 4" }}>
//                 <FormInputs label="Status" value={status} disabled />
//               </div>
//               <div className="item10" style={{ gridColumn: "1 / -1" }}>
//                 <FormInputs label="Comments" type="text" value={comments} disabled />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* QUESTION REVIEWER GROUP */}
//       <div className="ques-paper-del">
//         <div className="personal-header"><div className="header"><label>QUESTION REVIEWER GROUP</label></div></div>
//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs label="Is this a Question Reviewer Group?" type="text" value={reviewerGroupLabel()} disabled />
//               </div>
//               <div className="item2">
//                 <FormInputs label="Course" type="text" value={courseNameField || courseIdField} disabled />
//               </div>
//               <div className="item3">
//                 <FormInputs label="Subject" type="text" value={subjectNameField || subjectIdField} disabled />
//               </div>
//               <div className="item4">
//                 <FormInputs label="HOD or Faculty Reviewer Group?" type="text" value={reviewerGroupType} disabled />
//               </div>
//               <div className="item5">
//                 <FormInputs label="Reviewer Level" type="text" value={facultyReviewLevel ? String(facultyReviewLevel) : ""} disabled />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ROLES */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header"><label>ROLES</label></div>
//           <div className="accordion-btn" onClick={() => setIsOpenAddScreens(!isOpenAddScreens)}>
//             {isOpenAddScreens ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenAddScreens && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del" style={{ padding: "20px 0px 20px 10px" }}>
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1" style={{ gridColumn: "1 / -1" }}>
//                   <DropdownWithPagination
//                     label="Search Role"
//                     width="31%"
//                     selected={selectedUserGroups}
//                     setSelected={setSelectedUserGroups}
//                     onSearchInputChange={fetchUserGroups}
//                     options={userGroupOptions}
//                     isRequired={true}
//                     showSelectAll={false}
//                     allowMultiple={true}
//                     itemsPerPage={4}
//                     placeholder={isUserGroupEnabled ? "Type Role Name or Screen name or Report Name..." : "Type Role Name"}
//                     showLabelCheckbox={true}
//                     labelCheckboxChecked={isUserGroupEnabled}
//                     onLabelCheckboxChange={setIsUserGroupEnabled}
//                     labelCheckboxText="Search by Screen/Report Name"
//                     // disable dropdown when default group is true
//                     isDisabled={defGroupTrue}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
//                   <TableWithCrossStudentGroup
//                     headers={headersForUserGroups}
//                     data={tableDataForUserGroups}
//                     searchPlaceholder="Search user groups..."
//                     selectedRows={selectedUserGroups}
//                     setSelectedRows={setSelectedUserGroups}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteRowForUserGroups}
//                     isEditMode={!defGroupTrue}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default UserGroupRoleAccess;


















import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
import { API_BASE_URL } from "../../../Config/Config";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import { fetchSessionData } from "../../../Redux/Sessions/sessionSlice";
import SuccessImg from "../../../Assets/Images/CommanImages/Informative.png";
import "./updatedusergroup.css";
import EndPoints from "../../../Api/Endpoints";

function UserGroupRoleAccess({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { coursesdata } = useSelector((state) => state.course);
  const { sessionsData } = useSelector((state) => state.sessions);

  const accessToken = localStorage.getItem("other");
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

  // Received from table: either selectedRowsData (array of rows) + headers,
  // OR a single row via rowData+headers (from hyperlink). Support both.
  const passedHeaders = location.state?.headers ?? [];
  const passedSelectedRowsData = location.state?.selectedRowsData ?? null;
  const passedRow = location.state?.rowData ?? null;

  // We'll pick the "sourceRow" (array) from selectedRowsData[0] if provided else rowData
  const sourceRow = Array.isArray(passedSelectedRowsData) && passedSelectedRowsData.length > 0
    ? passedSelectedRowsData[0]
    : Array.isArray(passedRow)
    ? passedRow
    : [];

  // helper to get value by header name (header expected cleaned to readable name)
  const getByHeaderFrom = (headersArray, rowArray, headerName) => {
    if (!Array.isArray(headersArray) || headersArray.length === 0) return "";
    const idx = headersArray.indexOf(headerName);
    if (idx === -1) return "";
    const val = rowArray[idx];
    return val === null || val === undefined ? "" : val;
  };

  // Also try to be tolerant if headers have prefixes like "t*" or "n*"
  const getByAnyHeader = (names) => {
    for (const n of names) {
      // direct
      const v = getByHeaderFrom(passedHeaders, sourceRow, n);
      if (v !== "") return v;
      // and prefixed variant (strip potential prefixes in headers array)
      const prefixedIndex = passedHeaders.findIndex((h) =>
        String(h).endsWith(n) || String(h).replace(/^[a-z]\*/, "") === n
      );
      if (prefixedIndex !== -1) {
        const val = sourceRow[prefixedIndex];
        if (val !== undefined && val !== null && val !== "") return val;
      }
    }
    return "";
  };

  // Build initial states using header mapping (use getByAnyHeader over common names)
  const [studentGroupName, setStudentGroupName] = useState(() =>
    getByAnyHeader(["User Group Name", "UserGroupName", "User Group_Name", "User Group name"])
  );
  const [studentGroupDesc, setStudentGroupDesc] = useState(() =>
    getByAnyHeader(["User Group Description", "UserGroupDescription", "User Group Description"])
  );
  const [emailFlag, setEmailFlag] = useState(() =>
    getByAnyHeader(["Email Flag", "EmailFlag"])
  );
  const [messageFlag, setMessageFlag] = useState(() =>
    getByAnyHeader(["Message Flag", "MessageFlag"])
  );
  const [comments, setComments] = useState(() =>
    getByAnyHeader(["Comments"])
  );
  const [status, setStatus] = useState(() =>
    getByAnyHeader(["Status"])
  );
  const [lastModifiedDate, setLastModifiedDate] = useState(() =>
    getByAnyHeader(["Last Modified Date", "LastModifiedDate"])
  );
  const [createdBy, setCreatedBy] = useState(() =>
    getByAnyHeader(["Created By", "CreatedBy"])
  );
  const [groupOwnerName, setGroupOwnerNameState] = useState(() =>
    getByAnyHeader(["Group Owner Name", "GroupOwnerName"])
  );
  const [defaultUserGroup, setDefaultUserGroup] = useState(() =>
    getByAnyHeader(["Default Group", "DefaultUserGroup"])
  );

  // QUESTION REVIEWER GROUP fields
  const [quesReviewerGroupId, setQuesReviewerGroupId] = useState(() =>
    getByAnyHeader(["Ques Reviewer Group ID", "QuesReviewerGroupID"])
  );
  const [courseIdField, setCourseIdField] = useState(() =>
    getByAnyHeader(["Course ID", "CourseID"])
  );
  const [courseNameField, setCourseNameField] = useState(() =>
    getByAnyHeader(["Course Name", "CourseName"])
  );
  const [subjectIdField, setSubjectIdField] = useState(() =>
    getByAnyHeader(["Subject ID", "SubjectID"])
  );
  const [subjectNameField, setSubjectNameField] = useState(() =>
    getByAnyHeader(["Subject Name", "SubjectName"])
  );
  const [reviewerGroupType, setReviewerGroupType] = useState(() =>
    getByAnyHeader(["Reviewer Group Type", "ReviewerGroupType"])
  );
  const [facultyReviewLevel, setFacultyReviewLevel] = useState(() =>
    getByAnyHeader(["Faculty Review Level", "FacultyReviewLevel"])
  );

  // user_group_id extracted from incoming row (needed for GET roles by group & update)
  const [userGroupId, setUserGroupId] = useState(() =>
    getByAnyHeader(["User Group ID", "UserGroupID", "user_group_id"])
  );

  // If location.state later changes (unlikely), update fields accordingly
  useEffect(() => {
    setStudentGroupName(getByAnyHeader(["User Group Name", "UserGroupName"]));
    setStudentGroupDesc(getByAnyHeader(["User Group Description", "UserGroupDescription"]));
    setEmailFlag(getByAnyHeader(["Email Flag", "EmailFlag"]));
    setMessageFlag(getByAnyHeader(["Message Flag", "MessageFlag"]));
    setComments(getByAnyHeader(["Comments"]));
    setStatus(getByAnyHeader(["Status"]));
    setLastModifiedDate(getByAnyHeader(["Last Modified Date", "LastModifiedDate"]));
    setCreatedBy(getByAnyHeader(["Created By", "CreatedBy"]));
    setGroupOwnerNameState(getByAnyHeader(["Group Owner Name", "GroupOwnerName"]));
    setDefaultUserGroup(getByAnyHeader(["Default Group", "DefaultUserGroup"]));
    setQuesReviewerGroupId(getByAnyHeader(["Ques Reviewer Group ID", "QuesReviewerGroupID"]));
    setCourseIdField(getByAnyHeader(["Course ID", "CourseID"]));
    setCourseNameField(getByAnyHeader(["Course Name", "CourseName"]));
    setSubjectIdField(getByAnyHeader(["Subject ID", "SubjectID"]));
    setSubjectNameField(getByAnyHeader(["Subject Name", "SubjectName"]));
    setReviewerGroupType(getByAnyHeader(["Reviewer Group Type", "ReviewerGroupType"]));
    setFacultyReviewLevel(getByAnyHeader(["Faculty Review Level", "FacultyReviewLevel"]));
    setUserGroupId(getByAnyHeader(["User Group ID", "UserGroupID", "user_group_id"]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  // keep user-groups/roles block states
  const [selectedUserGroups, setSelectedUserGroups] = useState([]);
  const [initialSelectedUserGroups, setInitialSelectedUserGroups] = useState([]); // for dirty check
  const [userGroupOptions, setUserGroupOptions] = useState([]);
  const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);
  const [isOpenAddScreens, setIsOpenAddScreens] = useState(true);
  const isUpdatingFromTable = useRef(false);

  // load course/session lists
  useEffect(() => {
    dispatch(fetchCourseData());
    dispatch(fetchSessionData());
  }, [dispatch]);

  // fetch roles by search-key (server-side) - unchanged logic except new endpoint merge behavior
  const fetchUserGroups = async (searchKey) => {
    // if default group is true, search must be inactive
    const defGroupTrue = String(defaultUserGroup).toLowerCase() === "true" || defaultUserGroup === true;
    if (defGroupTrue) {
      // keep selections but do not fetch anything new
      setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
      return;
    }

    // if user cleared input AND there are no selected roles, clear options
    if (!searchKey?.trim()) {
      // keep selected ones (so table can still render selected rows)
      setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
      return;
    }

    try {
      const res = await fetch(
        `${EndPoints.PRISM_GET_ALL_ROLES_BY_SEARCH_KEY}?client_branch_id=${clientBranchId}&user_name=${userName}&search_key=${encodeURIComponent(
          searchKey
        )}&search_by_screen_report_name=${isUserGroupEnabled}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      const result = await res.json();

      if (result.status === 200 && Array.isArray(result.data)) {
        // map API roles -> dropdown options
        const incomingOptions = result.data.map((r) => ({
          id: r.role_id,
          // label: r.role_name || r.role_code || `Role ${r.role_id}`,
          label: `${r.role_code}/${r.role_name}/${r.role_desc}`.trim(),
          fullData: r,
        }));

        // merge with currently selected options so we don't lose them
        // setUserGroupOptions((prev) => {
        //   const selectedPrev = Array.isArray(prev) ? prev.filter((p) => selectedUserGroups.includes(p.id)) : [];
        //   // add incoming that aren't already in selectedPrev
        //   const merged = [
        //     ...selectedPrev,
        //     ...incomingOptions.filter((inc) => !selectedPrev.some((p) => p.id === inc.id)),
        //   ];
        //   return merged;
        // });
        setUserGroupOptions((prev = []) => {
          // put incoming search results first, then append any previous options that are not duplicates
          const map = new Map();
          // add incoming first
          incomingOptions.forEach((inc) => map.set(String(inc.id), inc));
          // append previous ones only if id not already present
          (prev || []).forEach((p) => {
            if (!map.has(String(p.id))) map.set(String(p.id), p);
          });
          return Array.from(map.values());
        });
      } else {
        // no results: keep selected ones only
        setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
      }
    } catch (err) {
      console.error("Error fetching roles:", err);
      // on error, keep selected ones so table doesn't break
      setUserGroupOptions((prev) => prev.filter((o) => selectedUserGroups.includes(o.id)));
    }
  };

  // NEW: fetch existing roles for this user group id and populate selectedUserGroups + options
  useEffect(() => {
    const fetchRolesByUserGroupId = async (ugId) => {
      if (!ugId) return;
      try {
        const res = await fetch(
          `${EndPoints.PRISM_GET_ROLES_BY_USER_GROUP_ID}?user_group_id=${ugId}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        const result = await res.json();
        if (result.status === 200 && Array.isArray(result.data)) {
          // if default group true, we must hide roles (as per requirement)
          const defGroupTrue = String(defaultUserGroup).toLowerCase() === "true" || defaultUserGroup === true;
          if (defGroupTrue) {
            // clear display and disable search/save via other logic
            setUserGroupOptions([]);
            setSelectedUserGroups([]);
            setInitialSelectedUserGroups([]);
            return;
          }

          const opts = result.data.map((r) => ({
            id: r.role_id,
            label: r.role_name || r.role_code || `Role ${r.role_id}`,
            fullData: r,
          }));

          const ids = opts.map((o) => o.id);

          setUserGroupOptions(opts);
          setSelectedUserGroups(ids);
          setInitialSelectedUserGroups(ids);
        } else {
          setUserGroupOptions([]);
          setSelectedUserGroups([]);
          setInitialSelectedUserGroups([]);
        }
      } catch (err) {
        console.error("Error fetching roles by group id:", err);
        setUserGroupOptions([]);
        setSelectedUserGroups([]);
        setInitialSelectedUserGroups([]);
      }
    };

    // ensure userGroupId is numeric or present
    if (userGroupId) {
      fetchRolesByUserGroupId(userGroupId);
    } else {
      // if no group id (maybe new), clear
      setUserGroupOptions([]);
      setSelectedUserGroups([]);
      setInitialSelectedUserGroups([]);
    }
    // run when userGroupId or defaultUserGroup changes
  }, [userGroupId, defaultUserGroup]); // eslint-disable-line

  // Roles table config
  const headersForUserGroups = [
    "Role ID",
    "Role Code",
    "Role Name",
    "Role Description",
    "Status",
    "Created Date",
    "No Of Users",
    "Screen Names",
    "Report Names",
  ];

  // Build table data for roles (first column must be id as table uses row[0] as id)
  const tableDataForUserGroups = selectedUserGroups
    .map((id) => {
      const opt = userGroupOptions.find((o) => o.id === id);
      if (!opt?.fullData) return null;
      const g = opt.fullData;
      // create screen_names and report_names as newline separated string (for multiline rendering)
      const screens = Array.isArray(g.screen_names) && g.screen_names.length > 0 ? g.screen_names.join("\n") : "";
      const reports = Array.isArray(g.report_names) && g.report_names.length > 0 ? g.report_names.join("\n") : "";

      return [
        id,
        g.role_name || "---",
         g.role_code || "---",
        g.role_desc || "---",
        g.status || "---",
        g.create_date ? String(g.create_date) : "---",
        typeof g.no_of_users !== "undefined" ? g.no_of_users : "---",
        screens,
        reports,
      ];
    })
    .filter(Boolean);

  const handleDeleteRowForUserGroups = (rowId) => {
    setUserGroupOptions((prev) => prev.filter((o) => o.id !== rowId));
    setSelectedUserGroups((prev) => prev.filter((id) => id !== rowId));
  };

  // helper: check dirty (selected changed vs initial)
  const isDirty = () => {
    // both arrays of ids
    const a = Array.isArray(initialSelectedUserGroups) ? initialSelectedUserGroups.slice().sort((x,y)=>x-y) : [];
    const b = Array.isArray(selectedUserGroups) ? selectedUserGroups.slice().sort((x,y)=>x-y) : [];
    if (a.length !== b.length) return true;
    for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return true;
    return false;
  };

  const reviewerGroupLabel = () => {
    if (quesReviewerGroupId === "" || quesReviewerGroupId === null || quesReviewerGroupId == "NA") return "No";
    // return String(quesReviewerGroupId);
    return "Yes";
  };

  // SAVE (update) — call update-user-group-roles API
  const handleSave = async () => {
    // if default group true, don't allow save
    const defGroupTrue = String(defaultUserGroup).toLowerCase() === "true" || defaultUserGroup === true;
    if (defGroupTrue) return;

    // only save when dirty
    if (!isDirty()) return;

    // payload: list of role ids in body; user_group_id & user_name as query params
    try {
      const payload = selectedUserGroups || [];
      const res = await fetch(
        `${EndPoints.PRISM_UPDATE_USER_GROUP_ROLES}?user_group_id=${userGroupId}&user_name=${userName}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await res.json();
      if (result && (result.status === 200 || result.status === "200")) {
        // update initial selected to current so SAVE becomes dim again
        setInitialSelectedUserGroups([...selectedUserGroups]);

        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>{result.message}</span>
              </div>
            </div>
          );
          setActiveImg(SuccessImg);
          setIsMessageBoxVisible(true);
          setTimeout(() => setIsMessageBoxVisible(false), 2000);
        }
      } else {
        // show error
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <span>Failed to save roles. Try again.</span>
              </div>
            </div>
          );
          setActiveImg(null);
          setIsMessageBoxVisible(true);
          setTimeout(() => setIsMessageBoxVisible(false), 3000);
        }
      }
    } catch (err) {
      console.error("Error updating user group roles:", err);
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>Failed to save roles. Try again.</span>
            </div>
          </div>
        );
        setActiveImg(null);
        setIsMessageBoxVisible(true);
        setTimeout(() => setIsMessageBoxVisible(false), 3000);
      }
    }
  };

  // decide save button disabled state
  const defGroupTrue = String(defaultUserGroup).toLowerCase() === "true" || defaultUserGroup === true;

  // ---------- New: lock when group inactive ----------
  const groupsLocked = !!status && String(status).toLowerCase() === "inactive";
  const saveDisabled = defGroupTrue || !isDirty() || groupsLocked;

  // style to dim roles content when locked (header remains visible)
  const rolesContentStyle = groupsLocked ? { opacity: 0.45, pointerEvents: "none", backgroundColor: "rgba(255,255,255,0.5)" } : {};

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">User Group - Role Access</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={() => navigate("/user_groups_dashboard")}>
            CANCEL
          </button>
          <button
            className="cr-create-btn"
            onClick={handleSave}
            disabled={saveDisabled}
            style={{ opacity: saveDisabled ? 0.6 : 1, cursor: saveDisabled ? "not-allowed" : "pointer" }}
          >
            SAVE
          </button>
        </div>
      </div>

      {/* GROUP INFORMATION */}
      <div className="ques-paper-del">
        <div className="personal-header"><div className="header"><label>GROUP INFROMATION</label></div></div>
        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div className="item1">
                <FormInputs label="User Group Name" type="text" required value={studentGroupName} disabled />
              </div>
              <div className="item2">
                <FormInputs label="User Group Description" type="text" required value={studentGroupDesc} disabled />
              </div>
              <div className="item3">
                <FormInputs label="Message Enabled" value={messageFlag} disabled />
              </div>
              <div className="item4">
                <FormInputs label="Email Enabled" value={emailFlag} disabled />
              </div>
              <div className="item5">
                <FormInputs label="Created By" type="text" value={createdBy} disabled />
              </div>
              <div className="item6">
                <FormInputs label="Group Owner Name" value={groupOwnerName} disabled />
              </div>
              <div className="item7" style={{ gridColumn: "1 / 2" }}>
                <FormInputs label="Last Modified Date" type="text" value={lastModifiedDate} disabled />
              </div>
              <div className="item8" style={{ gridColumn: "2 / 3" }}>
                <FormInputs label="Default Group" value={defaultUserGroup} disabled />
              </div>
              <div className="item9" style={{ gridColumn: "3 / 4" }}>
                <FormInputs label="Status" value={status} disabled />
              </div>
              <div className="item10" style={{ gridColumn: "1 / -1" }}>
                <FormInputs label="Comments" type="text" value={comments && comments.trim() !== "" ? comments : "-NA-"} disabled />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* QUESTION REVIEWER GROUP */}
      <div className="ques-paper-del">
        <div className="personal-header"><div className="header"><label>QUESTION REVIEWER GROUP</label></div></div>
        {/* <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div className="item1">
                <FormInputs label="Is this a Question Reviewer Group?" type="text" value={reviewerGroupLabel()} disabled />
              </div>
              <div className="item2">
                <FormInputs label="Course" type="text" value={courseNameField || courseIdField} disabled />
              </div>
              <div className="item3">
                <FormInputs label="Subject" type="text" value={subjectNameField || subjectIdField} disabled />
              </div>
              <div className="item4">
                <FormInputs label="HOD or Faculty Reviewer Group?" type="text" value={reviewerGroupType} disabled />
              </div>
              <div className="item5">
                <FormInputs label="Reviewer Level" type="text" value={facultyReviewLevel ? String(facultyReviewLevel) : ""} disabled />
              </div>
            </div>
          </div>
        </div> */}
        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div className="item1">
                <FormInputs
                  label="Is this a Question Reviewer Group?"
                  type="text"
                  value={reviewerGroupLabel()}
                  disabled
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="Course"
                  type="text"
                  value={courseNameField == "NA" ? "-NA-" : courseNameField}
                  disabled
                />
              </div>

              <div className="item3">
                <FormInputs
                  label="Subject"
                  type="text"
                  value={subjectNameField == "NA" ? "-NA-" : subjectNameField}
                  disabled
                />
              </div>

              <div className="item4">
                <FormInputs
                  label="HOD or Faculty Reviewer Group?"
                  type="text"
                  value={reviewerGroupType == "NA" ? "-NA-" : reviewerGroupType}
                  disabled
                />
              </div>

              <div className="item5">
                <FormInputs
                  label="Reviewer Level"
                  type="text"
                  value={
                    facultyReviewLevel == "NA" || facultyReviewLevel == "0"
                      ? "-NA-"
                      : String(facultyReviewLevel)
                  }
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ROLES */}
      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header"><label>ROLES</label></div>
          <div className="accordion-btn" onClick={() => setIsOpenAddScreens(!isOpenAddScreens)}>
            {isOpenAddScreens ? <div className="minus"></div> : <div className="plus">+</div>}
          </div>
        </div>

        {isOpenAddScreens && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del" style={{ padding: "20px 0px 20px 0px" }}>
              <div className="grid-container-ques-paper-del">
                <div className="item1" style={{ gridColumn: "1 / -1" , marginLeft: '20px' }}>
                  <div style={groupsLocked ? { opacity: 1 } : {}}>
                    <DropdownWithPagination
                      label="Search Role"
                      width="31%"
                      selected={selectedUserGroups}
                      setSelected={setSelectedUserGroups}
                      onSearchInputChange={fetchUserGroups}
                      options={userGroupOptions}
                      isRequired={true}
                      showSelectAll={false}
                      allowMultiple={true}
                      itemsPerPage={4}
                      placeholder={isUserGroupEnabled ? "Type Role Name or Screen name or Report Name..." : "Type Role Name"}
                      showLabelCheckbox={true}
                      labelCheckboxChecked={isUserGroupEnabled}
                      onLabelCheckboxChange={setIsUserGroupEnabled}
                      labelCheckboxText="Search by Screen/Report Name"
                      // disable dropdown when default group is true or group locked
                      isDisabled={defGroupTrue || groupsLocked} 
                    />
                  </div>
                </div>
                <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
                  <div style={rolesContentStyle}>
                    <TableWithCrossStudentGroup
                      headers={headersForUserGroups}
                      data={tableDataForUserGroups}
                      searchPlaceholder="Search user groups..."
                      selectedRows={selectedUserGroups}
                      setSelectedRows={setSelectedUserGroups}
                      renderQuestionText={(text) => text}
                      renderQuestionTextModel={(text) => text}
                      expandedStates={{}}
                      toggleImage={() => {}}
                      pageType="userEdit"
                      filterConfig={{}}
                      handleDeleteRow={handleDeleteRowForUserGroups}
                      isEditMode={!defGroupTrue && !groupsLocked}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserGroupRoleAccess;
